import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerLibroInventariModalComponent } from './worker-libro-inventari-modal';

export const WorkerLibroInventariModalModule: string = ng
    .module('worker-libro-inventari-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerLibroInventariModalComponent', WorkerLibroInventariModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-libro-inventari-modal/worker-libro-inventari-modal.module.ts